import { Expose } from "class-transformer";

export class UpdateManufacturerDto {
  @Expose()
  name: string;
}
